/* eslint-disable */
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'

import { Form, FormSpy } from 'react-final-form'

import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'

import WizardSlider from '@piconetworks/wizard-slider'
import { RemoteMarkdown } from '@piconetworks/remote-markdown'

import getFields, { isCustomFieldsValid } from 'apps/lib/getFields'
import observers from 'apps/lib/observers'
import Terms from 'apps/containers/Prompt/Login/Terms'

import ConditionAggregator from '@piconetworks/condition-aggregator'
import Spacing from '@piconetworks/spacing';

import WizardRedux from 'common/pkgs/WizardRedux'

import styles from './EnterEmail.module.scss'

import isEqual from 'lodash/isEqual'

const EnterEmail = ({
    popupId,
    onBackButtonClick,
    renderBackButton,
    signupEmail,
    welcomeBack,
    router,
    loginEmail,
    checkoutSelection,
}) => {
    const dispatch = useDispatch()
    const publisherId = useSelector(Loader.selectors.publisherId)

    const defaultPopup = useSelector(Loader.selectors.getDefaultPopup)

    const fields = useSelector(
        state => Loader.selectors.popupGetFields(state, popupId),
        isEqual
    )

    const customFields = getFields(fields)
    const linkColor = useSelector(Loader.selectors.linkColor)

    const allNewsletters = useSelector(Loader.selectors.allNewsletters)
    const popupNewsletters = useSelector((state) => Loader.selectors.popupNewsletters(state, popupId))
    const preSelectedNewsletters = popupNewsletters.map(({ id }) => id)

    const authenticationMethods = useSelector((state) => Loader.selectors.popupAuthenticationMethods(state, popupId || defaultPopup?.id))

    let customFieldsValid = (fields.length && !welcomeBack) ? false : true

    const signupCustomTextURL = useSelector((state) => Loader.selectors.getSignupPopupCustomTextFileNameById(state, popupId))

    //standard analytic props for signup
    const articleId = useSelector(Loader.selectors.articleId)
    const utm = useSelector(Zoid.selectors.getUTM)
    const origin = useSelector(Zoid.selectors.origin)
    const url = useSelector(Zoid.selectors.url)
    const referer = useSelector(Zoid.selectors.referer)

    const newsletters = getFields([{
        id: 'newsletters',
        title: !welcomeBack && allNewsletters.length
            ? (
                <div className={styles.newsletterTitle}>
                    Free Newsletters
                    <span className={styles.newsletterBadge}>{allNewsletters.length}</span>
                </div>
            ) : '',
        defaultValue: preSelectedNewsletters,
        description: 'newsletters description',
        type: 'Newsletters',
        required: false,
        order: 15,
    }])

    const emailLogin = getFields([{
        id: 'emailLogin',
        title: 'Email Login',
        description: '',
        type: 'EmailPasswordLogin',
        required: true,
        order: 15,
    }])

    const socialLogin = getFields([{
        id: 'socialLogin',
        title: '',
        description: 'click one',
        type: 'SocialLogin',
        required: false,
        order: 15,
        authenticationMethods
    }])

    const signupFormLogin = getFields([{
        id: 'signupFormLogin',
        title: 'Please confirm your email address.',
        defaultValue: signupEmail,
        description: 'click button',
        type: 'SignupForm',
        required: true,
        order: 15,
    }])

    const welcomeBackText = {
        title: 'Welcome back!',
        subtitle: 'Log in below to verify your identity',
    }

    const renderBackButtonText = {
        title: 'Create an account',
        subtitle: 'Continue below to complete your payment.',
    }

    const wizardSliderText = welcomeBack
        ? welcomeBackText
        : renderBackButton
            ? renderBackButtonText
            : {}
            

    return (
        <WizardSlider
            backButton={false}
            title={wizardSliderText.title || ''}
            subtitle={wizardSliderText.subtitle || ''}
            wizardHeaderClass="signupFormHeader"
            wizardContentClass="signupFormContent"
            onBackButtonClick={onBackButtonClick}
            linkColor={linkColor}
            renderBackButton={renderBackButton && !welcomeBack}
            markDown={signupCustomTextURL && (
                <RemoteMarkdown
                    linkColor={linkColor}
                    url={signupCustomTextURL}
                />
            )}
        >
            {loginEmail && (
                <WizardRedux.Step
                    validate={() => {
                        const errors = {}

                        return errors
                    }}
                    onSubmit={() => ({})}
                    render={({ form }) => {
                        form.submit()
                        return null
                    }}
                />
            )}

            <WizardRedux.Step
                onSubmit={({ values }) => {
                    const submitWizard = values?.wizardData?.submitWizard

                    if (!submitWizard) {
                        throw new Error('submitWizard not selected')
                    }
                    return {
                        submitWizard,
                    }
                }}
                rffProps={{
                    mutators: {
                        setWizardData: (args, state, utils) => {
                            utils.changeValue(state, 'wizardData', () => args[0])
                        },
                    },
                }}
                render={({
                    form,
                }) => (
                    <>
                        <ConditionAggregator
                            Submit={() => null}
                            onSubmit={async (e, data) => {
                                if (!welcomeBack && !data?.state?.customFields?.isComplete) {
                                    throw new Error('finish custom fields')
                                }

                                return {
                                    submitWizard: true,
                                }
                            }}
                            postSubmit={(data) => {
                                // advance to the next wizard step
                                form.mutators.setWizardData(data.submitResults)

                                form.submit()
                            }}
                            conditions={{
                                // markdown: {},
                                newsletters: {
                                    required: false,
                                    isComplete: true,
                                    Component: ({ changeCompletionStatus }) => (
                                        <Form
                                            keepDirtyOnReinitialize
                                            initialValues={{
                                                ...({ newsletters: preSelectedNewsletters }),
                                            }}
                                            onSubmit={(data) => { }}
                                            render={() => (
                                                <form>
                                                    <FormSpy
                                                        onChange={(props) => {
                                                            changeCompletionStatus({
                                                                isComplete: true,
                                                                ...props?.values,
                                                            })
                                                        }}
                                                    />
                                                    {!welcomeBack && newsletters.map((Field, idx) => (
                                                        <Field
                                                            key={idx}
                                                            linkColor={linkColor}
                                                            newsletterFilter={'preselected'}
                                                            newsletters={allNewsletters}
                                                        />
                                                    ))}
                                                </form>
                                            )}
                                        />
                                    ),
                                },
                                customFields: {
                                    required: true,
                                    isComplete: welcomeBack ? true : false,
                                    Component: ({ changeCompletionStatus }) => (
                                        <Form
                                            onSubmit={(data) => { }}
                                            render={() => !welcomeBack && (
                                                <form>
                                                    <FormSpy
                                                        onChange={(props) => {
                                                            customFieldsValid = isCustomFieldsValid(fields, props?.values)

                                                            if (customFieldsValid) {
                                                                changeCompletionStatus({
                                                                    isComplete: true,
                                                                    ...props?.values,
                                                                })
                                                            }
                                                        }}
                                                    />
                                                    {!welcomeBack && customFields.map((Field, idx) => (
                                                        <Field
                                                            key={idx}
                                                        />
                                                    ))}
                                                </form>
                                            )
                                            }
                                        />
                                    ),
                                },
                                ...(signupEmail && {
                                    signupFormLogin: {
                                        required: false,
                                        isComplete: false,
                                        preSubmit: async ({ state, payloads }) => {
                                            if (!welcomeBack && !state?.customFields?.isComplete) {
                                                throw new Error('Please complete all required fields.')
                                            }

                                            try {
                                                const email = state?.signupFormLogin?.isComplete && state.signupFormLogin.email

                                                if (email) {
                                                    const getHasPassword = await observers.getHasPassword({
                                                        dispatch,
                                                        payload: {
                                                            email,
                                                            publisherId,
                                                        },
                                                    })

                                                    if (getHasPassword?.hasPassword === false) {
                                                        const requestLoginLink = await observers.requestLoginLink({
                                                            dispatch,
                                                            payload: {
                                                                articleId,
                                                                customProperties: payloads?.customFields,
                                                                email,
                                                                newsletters: payloads?.newsletters.newsletters,
                                                                origin,
                                                                popupId,
                                                                publisherId,
                                                                redirectUrl: url,
                                                                referer,
                                                                utm,
                                                            },
                                                        })

                                                        if (requestLoginLink?.isNewRegistration) {
                                                            console.log('requestLoginLink')
                                                            return {}
                                                        } else {
                                                            throw new Error('Already registered')
                                                        }
                                                        // check your email for magic link
                                                    } else if (getHasPassword?.hasPassword === true) {
                                                        // ask for password
                                                    }
                                                }
                                            } catch (error) {
                                                console.log(error)
                                                if (error.message === 'Already registered'){
                                                    throw new Error ('This email is already associated with an account.')
                                                }
                                            }

                                            return {}
                                        },
                                        Component: ({
                                            changeCompletionStatus,
                                            submitConditionAggregator,
                                            errorMessage,
                                        }) => {
                                            useEffect(() => {
                                                if (errorMessage) {
                                                    changeCompletionStatus({
                                                        isComplete: false,
                                                    })
                                                }
                                            }, [errorMessage, changeCompletionStatus])

                                            return (
                                                <Form
                                                    onSubmit={async (data) => {
                                                        await changeCompletionStatus({
                                                            isComplete: true,
                                                            email: data.signupFormLogin,
                                                        })

                                                        submitConditionAggregator()
                                                    }}
                                                    render={({ handleSubmit }) => (
                                                        <form onSubmit={handleSubmit}>
                                                            {signupFormLogin.map((Field, idx) => (
                                                                <Field
                                                                    key={idx}
                                                                />
                                                            ))}
                                                        </form>
                                                    )}
                                                />
                                            )
                                        },
                                    }
                                }),
                                ...((
                                    (authenticationMethods.length && authenticationMethods.includes('email') && !signupEmail) ||
                                    welcomeBack
                                ) && {
                                    emailLogin: {
                                        required: false,
                                        isComplete: false,
                                        preSubmit: async ({ state }) => {
                                            if (!welcomeBack && !state?.customFields?.isComplete) {
                                                throw new Error('Please complete all required fields.')
                                            }
                                            return {}
                                        },
                                        Component: ({ submitConditionAggregator, isComplete, payloads }) => {
                                            if (isComplete) {
                                                submitConditionAggregator()

                                                return null
                                            }

                                            return (
                                                <Form
                                                    onSubmit={(data) => { }}
                                                    render={() => (
                                                        <>
                                                            <Terms />
                                                            {emailLogin.map((Field, idx) => (
                                                                <Field
                                                                    key={idx}
                                                                    customProperties={payloads?.customFields}
                                                                    newsletters={payloads?.newsletters.newsletters}
                                                                    disabled={!customFieldsValid}
                                                                    customFieldsValid={customFieldsValid}
                                                                    router={router}
                                                                    popupId={popupId}
                                                                    checkoutSelection={checkoutSelection}
                                                                />
                                                            ))}

                                                        </>
                                                    )}
                                                />
                                            )
                                        },
                                    }
                                }),
                                ...(!signupEmail && {
                                    socialLogin: {
                                        required: false,
                                        isComplete: false,
                                        preSubmit: async ({ state }) => {
                                            if (!welcomeBack && !state?.customFields?.isComplete) {
                                                throw new Error('Please complete all required fields.')
                                            }
                                            return {}
                                        },
                                        Component: ({ submitConditionAggregator, isComplete, payloads }) => {
                                            if (isComplete) {
                                                submitConditionAggregator()

                                                return null
                                            }

                                            return (
                                                <Form
                                                    onSubmit={(data) => { }}
                                                    render={() => (
                                                        <>
                                                            {!!(authenticationMethods.filter(method => method !== 'email').length) && (
                                                                <>
                                                                    {!authenticationMethods.includes('email') && (
                                                                        <Terms />
                                                                    )}
                                                                    <Spacing.HorizontalDivider withLine className={styles.or}>
                                                                        {authenticationMethods.includes('email') && 'OR '}
                                                                        SIGN UP WITH
                                                                    </Spacing.HorizontalDivider>
                                                                </>
                                                            )}
                                                            {socialLogin.map((Field, idx) => (
                                                                <Field
                                                                    key={idx}
                                                                    disabled={!customFieldsValid}
                                                                    popupId={popupId}
                                                                    customProperties={payloads?.customFields}
                                                                    newsletters={payloads?.newsletters}
                                                                />
                                                            ))}
                                                        </>
                                                    )}
                                                />
                                            )
                                        },
                                    }
                                }),
                            }}
                        />
                    </>
                )}
            />
        </WizardSlider>
    )
}

export default EnterEmail
